import "maplibre-gl/dist/maplibre-gl.css";
import React, { useRef, useEffect, useState, useContext } from "react";
import "../../styles/styles.scss";
import { useMapInstance } from "../../hooks/useMapInstance";
import { TranslationContext } from "../../index";
import LoadingState from "../common/LoadingState";
export var Map = function (_a) {
    var _b;
    var resources = _a.resources;
    var containerRef = useRef(null);
    var _c = useState(false), isReady = _c[0], setIsReady = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    var _e = useState(false), hasInteracted = _e[0], setHasInteracted = _e[1];
    var _f = useContext(TranslationContext), translations = _f.translations, language = _f.language;
    useEffect(function () {
        if (containerRef.current) {
            setIsReady(true);
        }
    }, []);
    var locations = resources.map(function (resource) { return ({
        coordinates: {
            lat: resource.coordinates.lat,
            lng: resource.coordinates.lng,
        },
        properties: {
            title: resource.title,
            location: resource.city,
            resourceUrl: resource.resourceUrl,
        },
    }); });
    useMapInstance({
        container: containerRef.current,
        locations: locations,
        enabled: isReady,
        onError: function (err) { return setError(err.message); },
        onInteraction: function () { return setHasInteracted(true); },
        scrollZoom: {
            around: 'center',
            requireModKey: true
        },
        language: language
    });
    if (error) {
        return React.createElement("div", { className: "map-error" },
            translations.errorLoadingMap,
            " ",
            error);
    }
    return (React.createElement("div", { className: "resource-map container" },
        React.createElement("div", { ref: containerRef, className: "map-container" }, !isReady && React.createElement(LoadingState, null)),
        !error && (React.createElement("div", { className: "map-overlay", "data-interacted": hasInteracted },
            React.createElement("div", { className: "map-overlay__header" },
                React.createElement("div", { className: "category" }, translations.exploreMap),
                React.createElement("h1", { className: "title", "aria-hidden": hasInteracted }, translations.mapTitle),
                React.createElement("p", { className: "description", "aria-hidden": hasInteracted }, translations.mapDescription)),
            React.createElement("div", { className: "map-overlay__footer" },
                React.createElement("a", { href: (_b = window.rmSettings) === null || _b === void 0 ? void 0 : _b.resourceUrl, className: "btn" }, translations.viewAllResources))))));
};
export default Map;
